module.exports = __webpack_public_path__ + "img/SSS-J-18.687a05d9.svg";